import React, { Component } from 'react'
import { Modal } from 'antd'
import styles from './ServerComponent.module.scss'
class ModalServerUnavailable extends Component { 
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      modalWidth: '35%',
      hasImage: false
    }
    this.contentRef = React.createRef()
  }
  componentDidMount = () => {
    const { isLayoutGuest = false, serverStatus } = this.props 
    if(isLayoutGuest && serverStatus && serverStatus.isOffline) {
      this.setState({ isModalOpen: true })
      this.checkForImages()
    } 
  }

  checkForImages = () => {
    const { serverStatus } = this.props
    if (serverStatus && serverStatus.maintainanceMessage) {
      // Check if the HTML content contains images
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = serverStatus.maintainanceMessage
      const images = tempDiv.querySelectorAll('img')
      
      if (images.length > 0) {
        this.setState({ hasImage: true })
        this.calculateModalSize(images[0])
      }
    }
  }

  calculateModalSize = (imgElement) => {
    // Create a temporary image to get natural dimensions
    const img = new Image()
    img.onload = () => {
      const screenWidth = window.innerWidth
      const screenHeight = window.innerHeight
      const maxWidth = screenWidth * 0.9 // 90% of screen width
      const maxHeight = screenHeight * 0.8 // 80% of screen height
      
      let modalWidth = Math.min(img.naturalWidth + 100, maxWidth) // Add padding
      let modalHeight = Math.min(img.naturalHeight + 150, maxHeight) // Add padding for header/footer
      
      // Ensure minimum size
      modalWidth = Math.max(modalWidth, 400)
      
      this.setState({ 
        modalWidth: `${modalWidth}px`,
        modalHeight: `${modalHeight}px`
      })
    }
    img.src = imgElement.src || imgElement.getAttribute('src')
  }
  UNSAFE_componentWillReceiveProps = (nextProps) => { 
    const { isLayoutGuest } = this.props
    let { isModalOpen } = this.state 
    if(nextProps.isModalOffline === true ) {
      isModalOpen = nextProps.isModalOffline
      this.setState({ isModalOpen: isModalOpen })
      if (isModalOpen) {
        setTimeout(() => this.checkForImages(), 100) // Delay to ensure content is rendered
      }
    } 
  }
  render() {
    
    const { serverStatus, setIsModalOffline } = this.props
    const { isModalOpen, modalWidth, hasImage } = this.state 
    
    const modalStyle = hasImage ? {
      width: modalWidth,
      maxWidth: '90vw',
      top: '5vh'
    } : {}
    
    return (
      <Modal
        visible={isModalOpen}
        footer={null}
        destroyOnClose
        className={`${styles.modalServerClose} ${hasImage ? styles.modalWithImage : ''}`}
        style={modalStyle}
        maskClosable={true}
        closable={true}
        keyboard={false}
        onCancel={() => { 
          this.setState({ isModalOpen : false })  
          if(setIsModalOffline) {
            setIsModalOffline(false)
          }
        }}
      >
        <div 
          ref={this.contentRef}
          className="quill-content"
          dangerouslySetInnerHTML={{ __html: serverStatus && serverStatus.maintainanceMessage }}
        /> 
      </Modal>
    )
  }
}
export default ModalServerUnavailable